import store from "~/js/store/store";
export default class HeaderMenu {
  constructor() {
    this.view = document.querySelector("._headerMenu");

    this.setup();
  }

  setup() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "scrollY") {
        this.updateHeaderVisible();
      }
    });
  }

  updateHeaderVisible() {
    if (!this.view) {
      return;
    }
    if (store.state.app.isPinSection) {
      return;
    }
    if (store.state.app.scrollY < 160) {
      this.view.classList.remove("scrolled");
      return;
    }
    if (store.getters["isScrollDown"]) {
      this.view.classList.add("scrolled");
    } else {
      this.view.classList.remove("scrolled");
    }
  }
}
